import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Lenis from 'lenis'

export function initSmoothScrolling() {
    const lenis = new Lenis({
        lerp: 0.1,
    })

    // Keep ScrollTrigger in sync with Lenis on every scroll event.
    lenis.on('scroll', ScrollTrigger.update)

    // Drive Lenis from GSAP's ticker (instead of its own rAF loop) so smooth
    // scroll and pinned/scrubbed ScrollTriggers update on the SAME frame.
    // Mismatched loops are what makes pinned sections look jumpy/jittery.
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000) // GSAP ticker time is in seconds; Lenis wants ms
    })
    gsap.ticker.lagSmoothing(0)

    let lastDirection = null

    // Shrink the header when scrolling down, restore it when scrolling up.
    lenis.on('scroll', ({ direction }) => {
        const HEADER = document.querySelector('#main-header')

        if (direction !== lastDirection) {
            if (direction === 1) {
                if (HEADER && !HEADER.classList.contains('shrink')) HEADER.classList.add('shrink')
            } else if (direction === -1) {
                if (HEADER && HEADER.classList.contains('shrink')) HEADER.classList.remove('shrink')
            }
            lastDirection = direction
        }
    })

    return lenis
}
